// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletTransactionListItem_wallet-transaction-list-item__ZmW\\+A {
  border-radius: 1.1rem;
  padding: 2rem 3rem;
  display: flex;
  align-items: center;
  gap: 4.5rem;
}

.WalletTransactionListItem_wallet-transaction-list-item--deduction__hthrt {
  background: var(--wallet-deduction);
}

.WalletTransactionListItem_wallet-transaction-list-item--topup__Pf6-L {
  background: var(--wallet-topup);
}

.WalletTransactionListItem_wallet-transaction-list-item__text__4TZMM {
  color: var(--black-light);
  font-size: var(--text-base);
  font-weight: 500;
}

.WalletTransactionListItem_wallet-transaction-list-item__value-wrapper__Yp1Is {
  color: var(--danger);
  font-weight: 700;
  margin-inline-start: auto;
}

.WalletTransactionListItem_wallet-transaction-list-item__value__qbSxo {
  font-size: var(--text-2xl);
  margin-inline-end: 1rem;
}

.WalletTransactionListItem_wallet-transaction-list-item__currency__tak6D {
  font-size: var(--text-sm);
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/Wallet/WalletTransactions/WalletTransactionList/WalletTransactionListItem/WalletTransactionListItem.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wallet-transaction-list-item {\n  border-radius: 1.1rem;\n  padding: 2rem 3rem;\n  display: flex;\n  align-items: center;\n  gap: 4.5rem;\n}\n\n.wallet-transaction-list-item--deduction {\n  background: var(--wallet-deduction);\n}\n\n.wallet-transaction-list-item--topup {\n  background: var(--wallet-topup);\n}\n\n.wallet-transaction-list-item__text {\n  color: var(--black-light);\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.wallet-transaction-list-item__value-wrapper {\n  color: var(--danger);\n  font-weight: 700;\n  margin-inline-start: auto;\n}\n\n.wallet-transaction-list-item__value {\n  font-size: var(--text-2xl);\n  margin-inline-end: 1rem;\n}\n\n.wallet-transaction-list-item__currency {\n  font-size: var(--text-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wallet-transaction-list-item": `WalletTransactionListItem_wallet-transaction-list-item__ZmW+A`,
	"wallet-transaction-list-item--deduction": `WalletTransactionListItem_wallet-transaction-list-item--deduction__hthrt`,
	"wallet-transaction-list-item--topup": `WalletTransactionListItem_wallet-transaction-list-item--topup__Pf6-L`,
	"wallet-transaction-list-item__text": `WalletTransactionListItem_wallet-transaction-list-item__text__4TZMM`,
	"wallet-transaction-list-item__value-wrapper": `WalletTransactionListItem_wallet-transaction-list-item__value-wrapper__Yp1Is`,
	"wallet-transaction-list-item__value": `WalletTransactionListItem_wallet-transaction-list-item__value__qbSxo`,
	"wallet-transaction-list-item__currency": `WalletTransactionListItem_wallet-transaction-list-item__currency__tak6D`
};
export default ___CSS_LOADER_EXPORT___;
